import { unauthenticatedPagePromo } from '@gonfalon/dogfood-flags/dogfood-flags';

import styles from '#components/ui/layout/InlineUnauthenticatedBanner.module.css';
import { UnauthenticatedPagePromos } from '#utils/unauthenticatedPage';

export const AgentControlBanner = () => {
  const activePromo = unauthenticatedPagePromo();

  if (activePromo !== UnauthenticatedPagePromos.agentControlLaunch2026) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <p className={styles.heading}>Try AgentControl free.</p>
      <p className={styles.description}>
        Stay on top of agent behavior in production. Access is included — log in for details.
      </p>
    </div>
  );
};
